var jcsfApp;
(function (jcsfApp) {
	var app;
	(function (app) {
		var member;
		(function (member) {
			var userController = (function () {
				function userController(
					$window,
					$rootScope,
					authService,
					constantService,
					dataService,
					valuesService
				) {
					this.$window = $window;
					this.$rootScope = $rootScope;
					this.authService = authService;
					this.constantService = constantService;
					this.dataService = dataService;
					this.valuesService = valuesService;
					this.stateList = valuesService.stateList;
					this.centerList = valuesService.centerList;
					this.roles = valuesService.roleList;

					authService.fillAuthData();
					valuesService.getStates();
					valuesService.getCenters();

					var id = $rootScope.$stateParams.id;
					if (!isNaN(id) && id > 0) {
						this.user = this.getUser(id);
					}
				}

				userController.prototype.getUser = function (id) {
					var $this = this;
					this.dataService
						.getSingle(this.constantService.apiProfileURI + id)
						.then(function (results) {
							$this.user = results;
							return $this.user;
						});
				};

				userController.prototype.cancel = function () {
					this.getUser(this.user.UserId);
				};

				userController.prototype.save = function () {
					var $this = this;
					var modifier = this.authService.authentication.userName;

					if (this.user.UserId < 1) {
						this.user.Creator = modifier;
					} else {
						this.user.LastModifiedBy = modifier;
					}

					const userCopy = structuredClone(this.user);
					delete userCopy.Roles;

					this.dataService
						.update(
							this.constantService.apiProfileURI + this.user.UserId,
							userCopy
						)
						.then(function (result) {
							result.Roles = $this.user.Roles;
							$this.user = result;
							$('#success-alert').alert();
							$('#success-alert')
								.fadeTo(2000, 500)
								.slideUp(500, function () {
									$('#success-alert').alert('close');
								});
						});
				};

				userController.prototype.toggleUserRole = function (role) {
					if (this.user.Roles == null) {
						this.user.Roles = [];
					}
					var idx = this.user.Roles.indexOf(role);
					var addRole = idx > -1;
					if (addRole) {
						this.user.Roles.splice(idx, 1);
					} else {
						this.user.Roles.push(role);
					}
					this.dataService.add(
						this.constantService.apiProfileURI +
							'setUserRole/' +
							this.user.UserId +
							'/' +
							role,
						{}
					);
				};
				userController.$inject = [
					'$window',
					'$rootScope',
					'authService',
					'constantService',
					'dataService',
					'valuesService',
				];
				return userController;
			})();
			angular.module('jcsfApp').controller('UserController', userController);
		})((member = app.member || (app.member = {})));
	})((app = jcsfApp.app || (jcsfApp.app = {})));
})(jcsfApp || (jcsfApp = {}));
